<div class="ctm-password-dialog">
  <!-- Header with CTM Logo -->
  <div class="dialog-header text-center">
    <div class="logo-wrapper mb-4">
      <img src="./assets/ctm-images/ctm-logo.svg" alt="Compare the Market" class="ctm-logo" />
    </div>
    <p class="fs-17 text-col21 mb-0">
      @if (isValidating) {
        Validating credentials...
      } @else {
        Please enter your credentials to access this environment
      }
    </p>
  </div>

  <mat-dialog-content class="dialog-content">
    @if (isValidating) {
      <!-- Loading State -->
      <div class="loading-container text-center py-5">
        <div class="spinner-wrapper mb-3">
          <div class="ctm-spinner"></div>
        </div>
        <p class="fs-17 fw600 text-ctmDefaultText mb-2">Verifying your credentials</p>
        <p class="fs-15 text-col21 mb-0">Please wait...</p>
      </div>
    } @else {
      <!-- Login Form -->
      <form (ngSubmit)="onSubmit()" #loginForm="ngForm" class="ctm-auth-form">
      <!-- Username Field -->
      <div class="form-group mb-3">
        <label class="form-label fs-17 fw600 text-ctmDefaultText mb-2">Username</label>
        <div class="input-wrapper">
          <input
            type="text"
            class="form-control ctm-input"
            [(ngModel)]="username"
            name="username"
            placeholder="Enter username"
            [disabled]="isLocked()"
            required
            autocomplete="username"
          />
        </div>
      </div>

      <!-- Password Field -->
      <div class="form-group mb-4">
        <label class="form-label fs-17 fw600 text-ctmDefaultText mb-2">Password</label>
        <div class="input-wrapper password-wrapper">
          <input
            [type]="showPassword ? 'text' : 'password'"
            class="form-control ctm-input"
            [(ngModel)]="password"
            name="password"
            placeholder="Enter password"
            [disabled]="isLocked()"
            required
            autocomplete="current-password"
          />
          <button
            type="button"
            class="password-toggle"
            (click)="togglePasswordVisibility()"
            [disabled]="isLocked()"
            [attr.aria-label]="'Toggle password visibility'"
          >
            <span class="toggle-text">{{ showPassword ? 'Hide' : 'Show' }}</span>
          </button>
        </div>
      </div>

      <!-- Error Message -->
      @if (errorMessage) {
        <div class="alert-box error-box mb-3" role="alert">
          <div>
            <p class="fs-15 fw700 text-col17 mb-1">Authentication Failed</p>
            <p class="fs-15 text-ctmDefaultText mb-0">{{ errorMessage }}</p>
          </div>
        </div>
      }

      <!-- Remaining Attempts -->
      @if (attemptCount > 0 && !isLocked()) {
        <div class="alert-box warning-box mb-3">
          <p class="fs-15 text-col34 mb-0">
            <strong class="fw700">{{ getRemainingAttempts() }}</strong> attempt(s) remaining before lockout
          </p>
        </div>
      }

      <!-- Action Buttons -->
      <div class="button-group d-grid gap-2">
        <button
          type="submit"
          class="btn btn-primary w-100"
          [disabled]="!username || !password || isLocked()"
        >
          <span class="text">Access Environment</span>
        </button>
        <button
          type="button"
          class="btn btn-primary-outline w-100"
          (click)="onClear()"
          [disabled]="isLocked()"
        >
          Clear Form
        </button>
      </div>
    </form>
    }
  </mat-dialog-content>

  <!-- Footer -->
  <div class="dialog-footer">
    <p class="fs-13 text-col21 text-center mb-0">
      This is a protected environment. Unauthorized access is prohibited.
    </p>
  </div>
</div>
